<!-- Start Breadcrumbs -->
<app-breadcrumbs
	title="Treemap Charts"
	[breadcrumbItems]="breadCrumbItems"
></app-breadcrumbs>
<!-- End Breadcrumbs -->

<div class="row">
	<div class="col-xl-6">
		<div class="card">
			<div class="card-header">
				<h4 class="card-title mb-0">Basic Treemap Charts</h4>
			</div>
			<!-- end card header -->

			<div class="card-body">
				<apx-chart
					[series]="basicTreemapChart.series"
					[chart]="basicTreemapChart.chart"
					[dataLabels]="basicTreemapChart.dataLabels"
					[plotOptions]="basicTreemapChart.plotOptions"
					[title]="basicTreemapChart.title"
					[legend]="basicTreemapChart.legend"
					[colors]="basicTreemapChart.colors"
				></apx-chart>
			</div>
			<!-- end card-body -->
		</div>
		<!-- end card -->
	</div>
	<!-- end col -->

	<div class="col-xl-6">
		<div class="card">
			<div class="card-header">
				<h4 class="card-title mb-0">Multi-Dimensional Treemap Chart</h4>
			</div>
			<!-- end card header -->

			<div class="card-body">
				<apx-chart
					[series]="MultiDimensionalChart.series"
					[chart]="MultiDimensionalChart.chart"
					[dataLabels]="MultiDimensionalChart.dataLabels"
					[plotOptions]="MultiDimensionalChart.plotOptions"
					[title]="MultiDimensionalChart.title"
					[legend]="MultiDimensionalChart.legend"
					[colors]="MultiDimensionalChart.colors"
				></apx-chart>
			</div>
			<!-- end card-body -->
		</div>
		<!-- end card -->
	</div>
	<!-- end col -->
</div>
<!-- end row -->

<div class="row">
	<div class="col-xl-6">
		<div class="card">
			<div class="card-header">
				<h4 class="card-title mb-0">
					Distributed Treemap Chart (Different Color for each Cell)
				</h4>
			</div>
			<!-- end card header -->

			<div class="card-body">
				<apx-chart
					[series]="distributedTreemapChart.series"
					[legend]="distributedTreemapChart.legend"
					[chart]="distributedTreemapChart.chart"
					[title]="distributedTreemapChart.title"
					[colors]="distributedTreemapChart.colors"
					[plotOptions]="distributedTreemapChart.plotOptions"
				></apx-chart>
			</div>
			<!-- end card-body -->
		</div>
		<!-- end card -->
	</div>
	<!-- end col -->

	<div class="col-xl-6">
		<div class="card">
			<div class="card-header">
				<h4 class="card-title mb-0">Treemap Chart with Color Ranges</h4>
			</div>
			<!-- end card header -->

			<div class="card-body">
				<apx-chart
					[series]="colorRangesChart.series"
					[chart]="colorRangesChart.chart"
					[dataLabels]="colorRangesChart.dataLabels"
					[plotOptions]="colorRangesChart.plotOptions"
					[title]="colorRangesChart.title"
					[legend]="colorRangesChart.legend"
				></apx-chart>
			</div>
			<!-- end card-body -->
		</div>
		<!-- end card -->
	</div>
	<!-- end col -->
</div>
<!-- end row -->
